import React, {useEffect, useState} from 'react';
import DeleteIcon from '../adminIcons/DeleteIcon.svg'
import EditIcon from '../adminIcons/EditIcon.svg'
import PlusIcon from '../adminIcons/PlusIcon.svg'
import Copy from '../../app-main-content/icons/Copy.svg'
import { deletePlaylistForAdmin } from '../../actions/AdminPlaylistsActions'; 
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Modal from '../../app-main-content/Modal'
import useWindowDimentions from '../../app-main-content/hooks/useWindowDimentions';
import AddToGroup from './AddToGroup';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { Store } from 'react-notifications-component'
import Notification from '../../app-main-content/playlistAdds/Notification'
import { formatSeconds } from '../../utils/formatTime'

const PlaylistComponent = (props) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    const [right, setRight] = useState(0)

    const [top, setTop] = useState(0)

    const {width, height} = useWindowDimentions()

    const [addActive, setAddActive] = useState(false)

    const urlForCopy = encodeURI(`${process.env.REACT_APP_API_URL}/playlist/${props.playlist.id}/${props.playlist.title}`)   


    const convertDate = (d) =>{
        var date = new Date(d); // parses ISO 8601
        return(date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear()+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds())
    }

    const deleteHandler = () => {
        var answer = window.confirm("Do you really want to delete the playlist?");
        if (answer) {
            dispatch(deletePlaylistForAdmin(props.playlist.id))
        }
    }

    const addClickHandler = (e) => {
        setRight(width-e.clientX+5)
        setTop(e.clientY)
        setAddActive(true)
    }

    const copyHandler = () => {
        Store.addNotification({
            content: <Notification message = {"Copied To Clipboard"}/>,
            type: 'custom',
            container: "bottom-center",
            insert: "top",
            dismiss: {
              duration: 2000,
              pauseOnHover: true
            }
          })
        }
    


    return (
        <div className='w-100 bg-success d-flex align-items-center px-3 py-1 border-top border-secondary'>
            <div 
                className = 'px-2' 
                onClick={()=>navigate(`/editPlaylist/${props.playlist.id}`)}
                role='button'
                style = {{width:'12%'}}>
                <img
                    className = 'w-100 p-1' 
                    alt = ""
                    src = {`https://img.cugate.com/?o=CUTV_PLAYLIST&i=${props.playlist.id}&s=300&qq=${Math.random()}`}
                    style={{aspectRatio:"14/9"}}/>
            </div>
            <div 
                className = 'text-white mx-2' 
                onClick={()=>navigate(`/editPlaylist/${props.playlist.id}`)}
                role='button'
                style = {{width:'35%'}}>
                {props.playlist.title}
            </div>
            <div 
                className = 'text-white mx-2' 
                onClick={()=>navigate(`/editPlaylist/${props.playlist.id}`)}
                role='button'
                style = {{width:'15%'}}>
                {formatSeconds(props.playlist.duration)}
            </div>
            <div 
                className = 'text-white mx-2' 
                onClick={()=>navigate(`/editPlaylist/${props.playlist.id}`)}
                role='button'
                style = {{width:'29%'}}>{
                    convertDate(props.playlist.updated)
                    }</div>
            <div className = 'mx-2 d-flex justify-content-around' style = {{width:'8%'}}>
                <img 
                    src = {EditIcon} alt = "" 
                    role='button'
                    onClick={()=>navigate(`/editPlaylist/${props.playlist.id}`)}/>
                <img src = {PlusIcon} alt = "" 
                    role='button'
                    onClick={addClickHandler}/>
                <CopyToClipboard text={urlForCopy}>
                    <img 
                        src = {Copy} alt = "" 
                        style={{width:"1.3rem", height:"1.3rem"}}
                        role='button'
                        onClick={() => copyHandler()}
                    />  
                </CopyToClipboard>
                <img 
                    src = {DeleteIcon} alt = "" 
                    role='button'
                    onClick={()=>deleteHandler()}
                />
            </div>
            <Modal 
                trigger = {addActive}
                setTrigger = {setAddActive}
                top = {top}
                right = {right}
                content = {
                    <AddToGroup
                        setIsActive = {setAddActive}
                        playlist = {props.playlist}
                        gr = {0}
                    /> 
                }
            /> 
        </div>
    );
};

export default PlaylistComponent;